import { createLocalStorageStore } from '@client/helpers/local-storage.helpers';

export const { useStore: useGroupByCategory, set: setGroupByCategory } =
  createLocalStorageStore('product_list_group_by_category', false);
